import { useEffect } from "react";

const FOOTER_HEIGHT = 90;
const DEFAULT_HEIGHT = `calc(100vh - ${FOOTER_HEIGHT}px)`;

const useGalleryAdsContainerStyles = (
  mobileCondition: boolean,
  showSideBar: boolean
) => {
  // Add new effect to handle gallery-ads-container height
  useEffect(() => {
    const updateAdsContainerHeight = (height: number) => {
      const adsContainer = document.querySelector(
        ".gallery-ads-container"
      ) as HTMLElement;
      const homeBgdImage = document.getElementById(
        "home-bgd-image"
      ) as HTMLElement;

      if (adsContainer && showSideBar && homeBgdImage) {
        if (!mobileCondition) {
          adsContainer.style.height = `${height}px`;
          adsContainer.style.maxHeight = `${height}px`;
          homeBgdImage.style.height = "100%";
        } else {
          adsContainer.style.height = `${height + 90}px`;
          adsContainer.style.maxHeight = `${height + 90}px`;
          homeBgdImage.style.height = "100%";
        }
      } else {
        adsContainer.style.height = DEFAULT_HEIGHT;
        adsContainer.style.maxHeight = DEFAULT_HEIGHT;
      }
    };

    const uploaderElement = document.querySelector(
      ".upload-complete-sidebar-container"
    );

    if (uploaderElement) {
      // Create a ResizeObserver to identify size changes
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const height = entry.contentRect.height;
          updateAdsContainerHeight(height);
        }
      });

      resizeObserver.observe(uploaderElement);

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, [mobileCondition, showSideBar]); // Re-run when showSideBar changes
};

export default useGalleryAdsContainerStyles;
